import React, { FC, ComponentProps } from 'react';
import { LazyComponent } from '@fiverr-private/ui_utils';
import { logClientError } from '../../utils';
import { PortfolioModalProps } from './PortfolioModal';

const lazyImport = () => import(/* webpackChunkName: 'PortfolioModal' */ './PortfolioModal');

export const LazyPortfolioModal: FC<Omit<ComponentProps<typeof LazyComponent<PortfolioModalProps>>, 'lazyImport'>> = ({
  onError,
  ...rest
}) => {
  const onErrorInner = (error) => {
    if (typeof onError === 'function') {
      onError(error);
    }

    logClientError({
      error,
      description: 'Failed to lazy load PortfolioModal',
    });
  };

  return <LazyComponent lazyImport={lazyImport} onError={onErrorInner} {...rest} />;
};
